export default __webpack_public_path__ + "09f5d7e73d035decea8ae5fbb65ad7b0.svg";